import { BlotterDetailsField } from '@/App/Blotter/grids/details/BlotterDetailsField.tsx';
import { PremiumDetailsField } from '@/App/Blotter/grids/option/details/PremiumDetailsField.tsx';
import { useUserContext } from '@/context/UserContext.tsx';
import type { BlotterOptionEntry } from '@/store/blotter/types/BlotterOptionEntry.ts';

type Props = {
  entry: BlotterOptionEntry;
};

export const VanillaFieldSet = ({ entry }: Props) => {
  const {
    currentUser: { userType },
  } = useUserContext();

  const isInternalSales = userType === 'Internal Sales';

  return (
    <div className="container-fluid">
      <div className="row">
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Option.details.way"
          labelI18NValues={{ isInternalSales }}
          value={`${entry.way} ${entry.currencyPair}`}
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Option.details.dealtAmount"
          formatting="amount"
          value={entry.dealtAmount}
          currency={entry.dealtCurrency}
          valueDataE2e="blotter-detailsPanel-dealtAmount"
        />
      </div>
      <div className="row">
        <PremiumDetailsField
          entry={entry}
          labelDataE2e="blotter-detailsPanel-premiumLabel"
          valueDataE2e="blotter-detailsPanel-premiumAmount"
        />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Option.details.strike"
          formatting="rate"
          value={entry.strike ?? 0}
        />
      </div>
      <div className="row">
        <BlotterDetailsField labelI18NKey="blotter.tab.Option.details.expiry" formatting="date" value={entry.expiry} />
        <BlotterDetailsField
          labelI18NKey="blotter.tab.Option.details.account"
          value={entry.account}
          minWidth="30ch"
          valueDataE2e="blotter-detailsPanel-account"
        />
      </div>
      <div className="row">
        <BlotterDetailsField
          singleColumn
          labelI18NKey="blotter.tab.Option.details.execTime"
          formatting="date"
          value={entry.execTime}
          valueDataE2e="blotter-detailsPanel-tradeDate"
        />
      </div>
    </div>
  );
};
